var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "phone-number",
      attrs: { label: _vm.label, prop: _vm.prop, rules: _vm.rules }
    },
    [
      _c("el-input", {
        attrs: {
          type: "text",
          clearable: true,
          maxlength: 15,
          resize: "none",
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          autofocus: _vm.autofocus
        },
        model: {
          value: _vm.phoneNumber,
          callback: function($$v) {
            _vm.phoneNumber = $$v
          },
          expression: "phoneNumber"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }